import styled from '@emotion/styled';

const CartWrapStyle = styled('div')`
    font-size: 16px;
    line-height: 1.2;

    .itemCart {
        margin-bottom: 16px;
    }
    .viewPayment {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        font-size: 20px;
        .name {
            font-weight: 700;
            span {
                font-weight: 400;
            }
        }
        .iconPlus {
            cursor: pointer;
        }
    }

    .group {
        padding: 10px 16px;

        .detail {
            display: flex;
            align-items: flex-start;
            gap: 5px;
            padding: 5px 0;

            .iconDetail {
                color: var(--orange-300);
                margin-top: 1px;
            }

            .titleDetail {
                width: 90%;
                padding-left: 5px;
            }
        }
    }

    .box-total {
        font-size: 16px;
        border-top: 1px solid var(--sand-400);
        padding-top: 16px;
        margin-top: 16px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 7px 0;
            .name {
                font-weight: 700;
            }
            .value {
                font-weight: 900;
            }
            &.total {
                .name {
                    font-size: 18px;
                }
                .value {
                    font-size: 22px;
                }
            }
        }
    }

    .extra-yards {
        .sub-title {
            font-weight: 700;
            font-size: 20px;
            margin-bottom: 6px;
        }
        .item {
            padding: 3px;
        }
        .icon-ex {
            color: var(--orange-300);
        }
    }

    .tee-times {
        border-radius: 6px;
        background: var(--blue-100);
        padding: 16px;
        font-size: 16px;
        margin-bottom: 24px;
        line-height: 1.5;

        .sub-title {
            font-weight: 700;
            margin-bottom: 3px;
        }
        .item {
            padding: 5px;
        }
    }

    &.mini-cart {
        .viewPayment {
            font-size: 16px;
        }
        .extra-yards {
            .sub-title {
                font-size: 18px;
            }
        }
        .tee-times {
            .item {
                font-size: 14px;
            }
        }
    }

    @media screen and (min-width: 768px) {
        .group {
            padding-left: 48px;
            padding-right: 48px;
        }

        &.mini-cart {
            .group {
                padding-left: 16px;
                padding-right: 16px;
            }
        }
    }
`;

export default CartWrapStyle;
